<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="标题" prop="title"><el-input v-model="formParameter.name"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="标签" prop="tags">
							<!--el-div v-model="formParameter.tags" autocomplete="off"!-->
							<el-tag :key="tag" v-for="tag in dynamicTags" closable
								:disable-transitions="false" @close="handleClose(tag)">
								{{ tag }}
							</el-tag>
							<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue"
								ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
								@blur="handleInputConfirm">
							</el-input>
							<el-button v-else class="button-new-tag" size="small" @click="showInput">+NewTag</el-button>
							<!--/el-div!-->	 
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="文章类型">
							<select-option-dictionary @change="chgType($event)"
								v-model="types"
								dkey="news-type"></select-option-dictionary>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="摘要" prop="summary"><el-input v-model="formParameter.summary"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<!-- <el-form-item label="内容" prop="content"><el-input v-model="formParameter.content"
								autocomplete="off"></el-input></el-form-item> -->
						<el-form-item label="内容" prop="content">
							<wang-edit ref="ss" v-model="formParameter.content" autocomplete="off">
							</wang-edit>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="原出处" prop="orgurl"><el-input v-model="formParameter.orgurl"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>

			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确
				定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>

import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/online/onlinetrends/onlinetrends.js';
import wangEdit from '@/components/wangEdit/wangEdit.vue';
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";

export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
		wangEdit
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: { },
			rules: {

				//标题
				name: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
				],
				//摘要
				summary: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],
				//内容
				content: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],


			},
			dynamicTags: [],
			inputVisible: false,
			inputValue: '',
			types:1
		};
	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		chgType(e) {
			if (e != 1) {
				api.queryNewsType({ type: e }, response => {
					if (response.data) {
						this.formParameter = response.data;
						this.parameter.id = this.formParameter.id;
						this.$refs.ss.init(this.formParameter.content);
						if(this.formParameter.tags){
							this.dynamicTags = JSON.parse(this.formParameter.tags);
						}else{
							this.dynamicTags =[]
						}
	 
						
						this.$refs.popup.title = "修改 - " + (e == 2 ? '【线下课程页】' : (e == 3 ? '【关于我们页】' : '【极限编程页】'))
					} else {
						this.formParameter = { type: 1 };
						this.$refs.ss.init("");
						this.dynamicTags=[]

						this.parameter.id =null
						this.$refs.popup.title = "添加新闻"
					}

				});
			} else {
				this.formParameter = { type: 1 };
				this.$refs.ss.init("");
				this.dynamicTags=""
				this.parameter.id =null
				this.$refs.popup.title = "添加新闻"
			}
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {

				console.log(this.formParameter)

				this.formParameter.type = this.types
				this.formParameter.tags =  this.dynamicTags

				this.confirmLoading = true;
				if (!this.parameter.id) {
					//添加
					let parameter = this.$utils.merger(this.formParameter);
					api.save(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameter = this.$utils.merger(this.formParameter);
					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {  };
			this.types = 1
			this.$refs.ss.init();
			//清空每次标签
			this.inputValue = "";
			this.dynamicTags = [];
			//清楚校验
			this.$refs.form.clearValidate();

			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toUpdate(parameter, response => {
					this.formParameter = response.data;
					this.types = this.formParameter.type
					this.$refs.ss.init(this.formParameter.content);
					this.popupLoading = false;
					if(this.formParameter.tags){
							this.dynamicTags = JSON.parse(this.formParameter.tags);
					}
					this.dynamicTags =[]
				});
			} else {
				//添加
				this.popupLoading = false;
			}
		},
		handleClose(tag) {
			this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			this.formParameter.tags = this.dynamicTags;
		},

		showInput() {
			this.inputVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
		},

		handleInputConfirm() {
			let inputValue = this.inputValue;
			if (inputValue) {
				this.dynamicTags.push(inputValue);
				this.formParameter.tags = this.dynamicTags;
			}
			this.inputVisible = false;
			this.inputValue = '';
		}
	}
};

</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
<style>
.el-tag+.el-tag {
	margin-left: 10px;
}

.button-new-tag {
	margin-left: 10px;
	height: 32px;
	line-height: 30px;
	padding-top: 0;
	padding-bottom: 0;
}

.input-new-tag {
	width: 90px;
	margin-left: 10px;
	vertical-align: bottom;
}
</style>
